module.exports = __webpack_public_path__ + "static/media/social-media-icon.b9eb5a12.svg";